// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";
import NotificationsListAPI from "../utils/services/notifications.api";
import { setEncryptedStorageValue } from "../utils/helper";

const firebaseConfig = {
  apiKey: "AIzaSyDND4G3W1WENk-gtsUKhenaP40zsSDP-HI",
  authDomain: "a2b-deliver-dev.firebaseapp.com",
  projectId: "a2b-deliver-dev",
  storageBucket: "a2b-deliver-dev.firebasestorage.app",
  messagingSenderId: "170098307434",
  appId: "1:170098307434:web:33ad5ce80fae3648feb513",
  measurementId: "G-DPTXNW8MWR",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

export const generateToken = async () => {
  const { saveFirebaseToken } = NotificationsListAPI;
  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    const token = await getToken(messaging, {
      vapidKey:
        "BCng2yWyvICKGylYFGxwmTwC0B5bOUrcY-8nTbSRDDOQ_rvA5B9OB7emyRllUfioKatXdskppfY4hvwGKftrrGA",
    });
    setEncryptedStorageValue("fcmtoken", token);
    saveFirebaseToken(token);
  }
};
